module.exports = __webpack_public_path__ + "static/media/back-arrow.94f08bb5.svg";